// utils/api.js or inside your component
const domianpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
export async function createHistory(historyData) {
  try {
    const response = await fetch(`${domianpath}/api/history`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(historyData),
    });

    if (!response.ok) {
      throw new Error("Failed to create history");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating history:", error);
    throw error;
  }
}
